import TablePartidas from "../common/table/TablePartidas.jsx";

const ReceiptElement = ({ data, dataPartidas, loadingPartidas, errorPartidas }) => {
  const bloqueResumen = [
    {
      bloque: "Resumen del documento",
      parametros: [
        { label: "ARC", accessor: "administrative_reference_code" },
        { label: "Número referencia local", accessor: "local_reference_number" },
        { label: "Nombre/Razón social Expedidor", accessor: "consignor_trader_name" },
        { label: "C.A.E. Expedidor", accessor: "consignor_trader_excise_number" },
        { label: "Nombre/Razón social Destinatario", accessor: "consignee_trader_name" },
        { label: "C.A.E. Destinatario", accessor: "consignee_trader_id" },
        { label: "N.I.F Destinatario", accessor: "message_recipient" },
      ],
    },
    {
      bloque: "Estado",
      parametros: [
        { label: "Situación", accessor: "situacion" },
        { label: "Procesado", render: () => data["processed"] ? "Completo" : "Incompleto" },
        { label: "Códigos faltantes", accessor: "cods_missing", default: "—" },
      ],
    },
  ];
  const bloques = [
    {
      bloque: "Header",
      parametros: [
        { label: "Emisor Mensaje", accessor: "message_sender" },
        { label: "Receptor Mensaje", accessor: "message_recipient" },
        { label: "Fecha Preparación", accessor: "date_of_preparation" },
        { label: "Hora Preparación", accessor: "time_of_preparation" },
        { label: "ID Mensaje", accessor: "message_identifier" },
      ],
    },
    {
      bloque: "Destinatario",
      parametros: [
        { label: "Idioma", accessor: "consignee_trader_language", default: "—" },
        { label: "ID Trader", accessor: "consignee_trader_id" },
        { label: "Nombre Trader", accessor: "consignee_trader_name" },
        { label: "Calle", render: (data) => `${data.consignee_street_name}, ${data.consignee_street_number}` },
        { label: "CP", accessor: "consignee_postcode" },
        { label: "Ciudad", accessor: "consignee_city" },
      ],
    },
    {
      bloque: "Movimiento de Impuestos",
      parametros: [
        { label: "ARC", accessor: "administrative_reference_code" },
        { label: "Fecha y Hora Validación", accessor: "date_and_time_of_validation" },
      ],
    },
    {
      bloque: "Expedidor",
      parametros: [
        { label: "Idioma", accessor: "consignor_trader_language", default: "—" },
        { label: "Número Excise", accessor: "consignor_trader_excise_number" },
        { label: "Nombre Trader", accessor: "consignor_trader_name" },
        { label: "Calle", render: (data) => `${data.consignor_street_name}, ${data.consignor_street_number}` },
        { label: "CP", accessor: "consignor_postcode" },
        { label: "Ciudad", accessor: "consignor_city" },
      ],
    },
    {
      bloque: "Lugar de Despacho",
      parametros: [
        { label: "Idioma", accessor: "place_of_dispatch_language", default: "—" },
        { label: "Ref. Almacén", accessor: "place_of_dispatch_reference_of_tax_warehouse" },
        { label: "Nombre Trader", accessor: "place_of_dispatch_trader_name" },
        { label: "Calle", accessor: "place_of_dispatch_street_name" },
        { label: "CP", accessor: "place_of_dispatch_postcode" },
        { label: "Ciudad", accessor: "place_of_dispatch_city" },
      ],
    },
    {
      bloque: "Autoridad Competente",
      parametros: [
        { label: "Ref. Autoridad", accessor: "competent_authority_reference_number" },
      ],
    },
    {
      bloque: "Documento EAD/ESAD",
      parametros: [
        { label: "Ref. Local", accessor: "local_reference_number" },
        { label: "Factura", accessor: "invoice_number" },
        { label: "Código Origen", accessor: "origin_type_code" },
        { label: "Fecha Despacho", accessor: "date_of_dispatch" },
      ],
    },
    {
      bloque: "Header EAD/ESAD",
      parametros: [
        { label: "Secuencia", accessor: "sequence_number" },
        { label: "Fecha y Hora Actualización", accessor: "date_and_time_of_update_validation" },
        { label: "Código Destino", accessor: "destination_type_code" },
        { label: "Tiempo Trayecto", accessor: "journey_time" },
        { label: "Transporte", accessor: "transport_arrangement" },
      ],
    },
    {
      bloque: "Modo de Transporte",
      parametros: [
        { label: "Código", accessor: "transport_mode_code" },
        { label: "Idioma complementaria", accessor: "transport_mode_complementary_information_language", default: "—" },
        { label: "Información Complementaria", accessor: "transport_mode_complementary_information", default: "—" },
      ],
    },
    {
      bloque: "Garantía de Movimiento",
      parametros: [
        { label: "Tipo Garantor", accessor: "guarantor_type_code" },
      ],
    },
  ];
  return (
    <div>
      {crearBloques(bloqueResumen, data)}
      <div key="partidas" className="border border-gray-200 rounded mb-6">
        <TablePartidas data={dataPartidas} loading={loadingPartidas} error={errorPartidas} />
      </div>
      {crearBloques(bloques, data)}
    </div>
  );
};

function crearBloques(bloques, data) {
  return (bloques.map(({ bloque, parametros }) => (
    <div key={bloque} className="border border-gray-200 rounded p-4 mb-6">
      <h2 className="text-gray-700 font-semibold mb-4">{bloque}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 text-sm">
        {parametros.map(({ label, accessor, render, default: def }) => (
          <div key={label} className="flex">
            <dt className="font-semibold text-blue-600">{label}:</dt>
            <dd className="ml-2 text-gray-800">
              {render
                ? render(data)
                : data[accessor] != null
                ? data[accessor]
                : def || "—"}
            </dd>
          </div>
        ))}
      </div>
    </div>
  )));
}

export default ReceiptElement;
